import React from 'react';
import AssignmentRoundedIcon from '@material-ui/icons/AssignmentRounded';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  addTicketState,
  editTicketState,
  ticketMenuOpenedState,
  actionsMenuOpenedState,
  analyticsMenuOpenedState,
  setTicketMenuOpened,
  setActionsMenuOpened,
  wagonMenuOpenedState,
  setWagonMenuOpened,
  setSelectedMenuTab,
  setInvoiceMenuOpened,
  invoiceMenuOpenedState,
  selectedMenuTabState,
  setAnalyticsMenuOpened,
  parametersMenuOpenedState,
  revisionPlanMenuOpenedState,
  setParametersMenuOpened,
  setRevisionPlanMenuOpened,
  technicalParametersMenuOpenedState,
  forecastParametersMenuOpenedState,
  setTechnicalParametersMenuOpened,
  setForecastParametersMenuOpened,
} from '../ContentTabs/ContentTabsSlice';
import { userInfoState } from '../HomeSlice';

import useStyles from './styles';

export default function DrawerMenu(props) {
  const { drawerOpened } = props;
  const ticketMenuOpened = useSelector(ticketMenuOpenedState);
  const actionsMenuOpened = useSelector(actionsMenuOpenedState);
  const wagonMenuOpened = useSelector(wagonMenuOpenedState);
  const invoiceMenuOpened = useSelector(invoiceMenuOpenedState);
  const analyticsMenuOpened = useSelector(analyticsMenuOpenedState);
  const parametersMenuOpened = useSelector(parametersMenuOpenedState);
  const revisionPlanMenuOpened = useSelector(revisionPlanMenuOpenedState);
  const addTicket = useSelector(addTicketState);
  const editTicket = useSelector(editTicketState);
  const user = useSelector(userInfoState);
  const selectedMenuTab = useSelector(selectedMenuTabState);
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const technicalParametersMenuOpened = useSelector(
    technicalParametersMenuOpenedState,
  );
  const forecastParametersMenuOpened = useSelector(
    forecastParametersMenuOpenedState,
  );

  const handleTicketMenuClick = () => {
    dispatch(setTicketMenuOpened(!ticketMenuOpened));
  };

  const handleActionsMenuClick = () => {
    dispatch(setActionsMenuOpened(!actionsMenuOpened));
  };

  const handleWagonMenuClick = () => {
    dispatch(setWagonMenuOpened(!wagonMenuOpened));
  };

  const handleInvoiceMenuClick = () => {
    dispatch(setInvoiceMenuOpened(!invoiceMenuOpened));
  };

  const handleAnalyticsMenuClick = () => {
    dispatch(setAnalyticsMenuOpened(!analyticsMenuOpened));
  };

  const handleParametersMenuClick = () => {
    dispatch(setParametersMenuOpened(!parametersMenuOpened));
  };

  const handleTechnicalParametersMenuClick = () => {
    dispatch(setTechnicalParametersMenuOpened(!technicalParametersMenuOpened));
  };

  const handleForecastParametersMenuClick = () => {
    dispatch(setForecastParametersMenuOpened(!forecastParametersMenuOpened));
  };

  const handleRevisionPlanMenuClick = () => {
    dispatch(setRevisionPlanMenuOpened(!revisionPlanMenuOpened));
  };

  const handleClickOnTicketList = () => {
    props.onChange('totalTickets');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('ticketList'));
      history.push('/');
    }
  };

  const handleClickOnNewTicket = () => {
    props.onChange('ticket');
  };

  const handleClickOnActionList = () => {
    props.onChange();
    dispatch(setSelectedMenuTab('actionList'));
    history.push('/action/list');
  };
  const handleClickOnActionCreation = () => {
    props.onChange('actionCreation');
    dispatch(setSelectedMenuTab('actionCreation'));
    history.push('/action/creation');
  };

  const handleClickOnWagonDetails = () => {
    props.onChange('wagonDetails');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('ticketHistoric'));
      history.push('/wagon/search');
    }
  };

  const handleClickOnAddInvoices = () => {
    props.onChange('addInvoices');
    if (!(addTicket || editTicket)) {
      dispatch(setSelectedMenuTab('addInvoices'));
      history.push('/invoices/add');
    }
  };

  const handleClickOnInvoicesResearch = () => {
    props.onChange('invoicesResearch');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('invoicesResearch'));
      history.push('/invoices/research');
    }
  };

  const handleClickOnWagonAvailability = () => {
    props.onChange('wagonAvailability');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('wagonAvailability'));
      history.push('/analytics/wagon-availability');
    }
  };

  const handleClickOnWagonSimulation = () => {
    props.onChange('wagonSimulation');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('wagonSimulation'));
      history.push('/analytics/wagon-simulation');
    }
  };

  const handleClickOnMaintenanceStatus = () => {
    props.onChange('maintenanceStatus');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('maintenanceStatus'));
      history.push('/analytics/maintenance-status');
    }
  };

  const handleClickOnWorkshopTime = () => {
    props.onChange('workshopTime');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('workshopTime'));
      history.push('/analytics/workshop-time');
    }
  };
  const handleClickOnTotalCost = () => {
    props.onChange('totalCost');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('totalCost'));
      history.push('/analytics/total-cost');
    }
  };
  // const handleClickOnMonitoring = () => {
  //   props.onChange('monitoring');
  //   if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
  //     dispatch(setSelectedMenuTab('monitoring'));
  //     history.push('/analytics/monitoring');
  //   }
  // };

  const handleClickOnActualWorkshops = () => {
    props.onChange('actualWorkshops');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('actualWorkshops'));
    history.push('/parameters/actualWorkshops');
    // }
  };

  const handleClickOnContactsEmail = () => {
    props.onChange('contactsEmail');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('contactsEmail'));
    history.push('/parameters/contactsEmail');
    // }
  };

  const handleClickOnGcuDamageCode = () => {
    props.onChange('gcuDamageCode');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('gcuDamageCode'));
    history.push('/parameters/gcuDamageCode');
    // }
  };

  const handleClickOnBusinessNeed = () => {
    props.onChange('businessNeed');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('businessNeed'));
    history.push('/parameters/businessNeed');
    // }
  };

  const handleClickOnParameterAr = () => {
    props.onChange('parameterAr');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('parameterAr'));
    history.push('/parameters/parameterAr');
    // }
  };

  const handleClickOnRevisionParameters = () => {
    props.onChange('revisionParameters');
    if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
      dispatch(setSelectedMenuTab('revisionParameters'));
      history.push('/parameters/revision');
    }
  };

  const handleClickOnDurationParameter = () => {
    props.onChange('durationParameter');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('durationParameter'));
    history.push('/parameters/durationParameter');
    // }
  };

  const handleClickOnParameterScraping = () => {
    props.onChange('parametersScraping');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('parametersScraping'));
    history.push('/parameters/parametersScraping');
    // }
  };

  const handleClickOnRevisionPlanUpload = () => {
    props.onChange('revisionPlanUpload');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('revisionPlanUpload'));
    history.push('/revisionplan/revisionPlanUpload');
    // }
  };

  const handleClickOnPlannedPrediction = () => {
    props.onChange('plannedPrediction');
    // if (!(addTicket || editTicket) && selectedMenuTab !== 'addInvoices') {
    dispatch(setSelectedMenuTab('plannedPrediction'));
    history.push('/revisionplan/plannedprediction');
    // }
  };

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={drawerOpened}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <div style={{ margin: '1px' }}>
        <ListItem
          button
          className={classes.listItem}
          data-testid="tickets-menu"
          onClick={handleTicketMenuClick}
        >
          <ListItemIcon className={classes.icon}>
            <AssignmentRoundedIcon />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.listItemText}
            primary={t('TICKETS')}
          />
          {ticketMenuOpened ? (
            <ArrowDropDownIcon className={classes.array} />
          ) : (
            <ArrowRightIcon className={classes.array} />
          )}
        </ListItem>
        <Collapse in={ticketMenuOpened} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="ticket-list"
              onClick={handleClickOnTicketList}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('ticket list')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="new-ticket"
              onClick={handleClickOnNewTicket}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('new ticket')}
              />
            </ListItem>
          </List>
        </Collapse>
        <Divider />
        <ListItem
          button
          className={classes.listItem}
          data-testid="actions-menu"
          onClick={handleActionsMenuClick}
        >
          <ListItemIcon className={classes.icon}>
            <AssignmentRoundedIcon />
          </ListItemIcon>
          <ListItemText
            disableTypography
            className={classes.listItemText}
            primary={t('actions')}
          />
          {actionsMenuOpened ? (
            <ArrowDropDownIcon className={classes.array} />
          ) : (
            <ArrowRightIcon className={classes.array} />
          )}
        </ListItem>
        <Collapse in={actionsMenuOpened} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="actions-list"
              onClick={handleClickOnActionList}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('actions_list')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="new-action"
              onClick={handleClickOnActionCreation}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('action_creation')}
              />
            </ListItem>
          </List>
        </Collapse>
        <Divider />
        {(user.hasEmilyDRights || user.internal || user.externalMax) && (
          <ListItem
            button
            data-testid="wagon-menu"
            className={classes.listItem}
            onClick={handleWagonMenuClick}
          >
            <ListItemIcon className={classes.icon}>
              <AssignmentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t('wagon')}
            />
            {wagonMenuOpened ? (
              <ArrowDropDownIcon className={classes.array} />
            ) : (
              <ArrowRightIcon className={classes.array} />
            )}
          </ListItem>
        )}
        <Collapse in={wagonMenuOpened} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="wagon-details"
              onClick={handleClickOnWagonDetails}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('wagon details')}
              />
            </ListItem>
          </List>
        </Collapse>
        <Divider />
        {(user.hasAllRights || user.hasEmilyDRights) && !user.externalMax && (
          <ListItem
            button
            data-testid="invoices-menu"
            className={classes.listItem}
            onClick={handleInvoiceMenuClick}
          >
            <ListItemIcon className={classes.icon}>
              <AssignmentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t('invoices')}
            />
            {invoiceMenuOpened ? (
              <ArrowDropDownIcon className={classes.array} />
            ) : (
              <ArrowRightIcon className={classes.array} />
            )}
          </ListItem>
        )}
        <Collapse in={invoiceMenuOpened} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="add-invoice"
              onClick={handleClickOnAddInvoices}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('add invoice')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="invoices-research"
              onClick={handleClickOnInvoicesResearch}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('invoices research')}
              />
            </ListItem>
          </List>
        </Collapse>
        <Divider />

        {/* {user.hasAllRights === true && ( */}
        {(user.internal || user.hasEmilyDRights) && (
          <ListItem
            button
            data-testid="analytics-menu"
            className={classes.listItem}
            onClick={handleAnalyticsMenuClick}
          >
            <ListItemIcon className={classes.icon}>
              <AssignmentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t('ANALYTICS')}
            />
            {analyticsMenuOpened ? (
              <ArrowDropDownIcon className={classes.array} />
            ) : (
              <ArrowRightIcon className={classes.array} />
            )}
          </ListItem>
        )}
        <Collapse in={analyticsMenuOpened} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* {user.hasAllRights === true && ( */}
            {(user.hasAllRights || user.hasEmilyDRights) && (
              <ListItem
                button
                data-testid="wagon-availability"
                onClick={handleClickOnWagonAvailability}
                className={`${classes.listItem} ${classes.selectedListItem}`}
              >
                <ListItemText
                  disableTypography
                  className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                  primary={t('WAGON AVAILABILITY')}
                />
              </ListItem>
            )}

            {user.hasAllRights && !user.hasEmilyDRights && (
              // {user.hasAllRights === true && (
              <ListItem
                button
                data-testid="wagon-simulation"
                onClick={handleClickOnWagonSimulation}
                className={`${classes.listItem} ${classes.selectedListItem}`}
              >
                <ListItemText
                  disableTypography
                  className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                  primary={t('WAGON SIMULATION')}
                />
              </ListItem>
            )}
            <ListItem
              button
              data-testid="maintenance-status"
              onClick={handleClickOnMaintenanceStatus}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('MAINTENANCE STATUS')}
              />
            </ListItem>

            <ListItem
              button
              data-testid="workshop-time"
              onClick={handleClickOnWorkshopTime}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('WORKSHOP TIME')}
              />
            </ListItem>

            {/* {user.hasAllRights && ( */}
            {user.hasAllRights && !user.hasEmilyDRights && (
              <ListItem
                button
                data-testid="total-cost"
                onClick={handleClickOnTotalCost}
                className={`${classes.listItem} ${classes.selectedListItem}`}
              >
                <ListItemText
                  disableTypography
                  className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                  primary={t('TOTAL COST OF OWNERSHIP')}
                />
              </ListItem>
            )}
            {/* {user.hasAllRights && !user.hasEmilyDRights && (
            <ListItem
              button
              data-testid="monitoring"
              onClick={handleClickOnMonitoring}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('MONITORING')}
              />
            </ListItem>
          )} */}
          </List>
        </Collapse>
        <Divider />
        {/* {user.hasAllRights === true &&
          user.internal === true &&
          user.externalMax === false && ( */}
        {user.hasAllRights === true && (
          <ListItem
            button
            data-testid="paramters-menu"
            className={classes.listItem}
            onClick={handleParametersMenuClick}
          >
            <ListItemIcon className={classes.icon}>
              <AssignmentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t('PARAMETERS')}
            />
            {parametersMenuOpened ? (
              <ArrowDropDownIcon className={classes.array} />
            ) : (
              <ArrowRightIcon className={classes.array} />
            )}
          </ListItem>
        )}

        {user.hasAllRights === true && (
          // {user.hasAllRights === true &&
          //   user.internal === true &&
          //   user.externalMax === false && (
          <Collapse in={parametersMenuOpened} timeout="auto" unmountOnExit>
            <ListItem
              button
              className={classes.listItem}
              data-testid="technical-parameters-menu"
              onClick={handleTechnicalParametersMenuClick}
            >
              <ListItemIcon className={classes.icon}>
                <AssignmentRoundedIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                className={classes.listItemText}
                primary={t('technical_parameters')}
              />
              {technicalParametersMenuOpened ? (
                <ArrowDropDownIcon className={classes.array} />
              ) : (
                <ArrowRightIcon className={classes.array} />
              )}
            </ListItem>
          </Collapse>
        )}
        <Collapse
          in={technicalParametersMenuOpened && parametersMenuOpened}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="test-actual-workshops"
              onClick={handleClickOnActualWorkshops}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('actual_workshops')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="test-contacts-email"
              onClick={handleClickOnContactsEmail}
              className={`${classes.listItem} ${classes.selectedlistItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('contacts_email')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="test-gcu-damage-code"
              onClick={handleClickOnGcuDamageCode}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('gcu_damage_code')}
              />
            </ListItem>
          </List>
        </Collapse>

        {user.hasAllRights === true && (
          // {user.hasAllRights === true &&
          //   user.internal === true &&
          //   user.externalMax === false && (
          <Collapse in={parametersMenuOpened} timeout="auto" unmountOnExit>
            <ListItem
              button
              className={classes.listItem}
              data-testid="forecast-parameters-menu"
              onClick={handleForecastParametersMenuClick}
            >
              <ListItemIcon className={classes.icon}>
                <AssignmentRoundedIcon />
              </ListItemIcon>
              <ListItemText
                disableTypography
                className={classes.listItemText}
                primary={t('forecast_parameters')}
              />
              {forecastParametersMenuOpened ? (
                <ArrowDropDownIcon className={classes.array} />
              ) : (
                <ArrowRightIcon className={classes.array} />
              )}
            </ListItem>
          </Collapse>
        )}
        <Collapse
          in={forecastParametersMenuOpened && parametersMenuOpened}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            <ListItem
              button
              data-testid="test-business-need"
              onClick={handleClickOnBusinessNeed}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('business_need')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="test-parameter-ar"
              onClick={handleClickOnParameterAr}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('parameter_ar')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="test-revision-parameter"
              onClick={handleClickOnRevisionParameters}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('REVISION PARAMETERS')}
              />
            </ListItem>
            <ListItem
              button
              datat-testid="test-duration-parameter"
              onClick={handleClickOnDurationParameter}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('duration_parameter')}
              />
            </ListItem>
            <ListItem
              button
              data-testid="test-parameter-scraping"
              onClick={handleClickOnParameterScraping}
              className={`${classes.listItem} ${classes.selectedListItem}`}
            >
              <ListItemText
                disableTypography
                className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                primary={t('parameter_scraping')}
              />
            </ListItem>
          </List>
        </Collapse>
        <Divider />

        {/* {user.hasAllRights === true && user.internal === true && ( */}
        {user.hasAllRights === true && (
          <ListItem
            button
            data-testid="revisionplan-menu"
            className={classes.listItem}
            onClick={handleRevisionPlanMenuClick}
          >
            <ListItemIcon className={classes.icon}>
              <AssignmentRoundedIcon />
            </ListItemIcon>
            <ListItemText
              disableTypography
              className={classes.listItemText}
              primary={t('revision_plan')}
            />
            {revisionPlanMenuOpened ? (
              <ArrowDropDownIcon className={classes.array} />
            ) : (
              <ArrowRightIcon className={classes.array} />
            )}
          </ListItem>
        )}

        {/* {user.hasAllRights === true && user.internal === true && ( */}
        {user.hasAllRights === true && (
          <Collapse in={revisionPlanMenuOpened} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                data-testid="test-revision-plan-upload"
                onClick={handleClickOnRevisionPlanUpload}
                className={`${classes.listItem} ${classes.selectedListItem}`}
              >
                <ListItemText
                  disableTypography
                  className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                  primary={t('revision_plan_upload')}
                />
              </ListItem>
              <ListItem
                button
                data-testid="test-revision-plan-checker"
                onClick={handleClickOnPlannedPrediction}
                className={`${classes.listItem} ${classes.selectedListItem}`}
              >
                <ListItemText
                  disableTypography
                  className={`${classes.listItemText} ${classes.selectedlistItemText}`}
                  primary={t('revision_plan_checker')}
                />
              </ListItem>
            </List>
          </Collapse>
        )}
        <Divider />
      </div>
    </Drawer>
  );
}
